import React from 'react'
import { Link, Outlet, useLocation } from 'react-router'
import { AppRoutes } from '@core/AppRoutes'
import { dayjs } from '@mobi/utils/date'
import { Tab } from '@core/Components/Tabs'
import { ContentHeader } from '@core/Components/ContentHeader'
import { BoldedTabList, TippingMainContainerStyled } from './TippingPage.styles'

export const TippingPage = (): JSX.Element | null => {
  const location = useLocation()

  const isShowingResults = /\/results/i.test(location.pathname)

  return (
    <TippingMainContainerStyled>
      <ContentHeader title='TIPPING' iconCode='TIPPING' />

      <BoldedTabList colorscheme='dark' uppercaseText={true}>
        <Tab selected={!isShowingResults}>
          <Link to={AppRoutes.Tipping}>Current</Link>
        </Tab>

        <Tab selected={isShowingResults}>
          <Link to={`results?date=${dayjs().format('YYYY-MM-DD')}`}>Results</Link>
        </Tab>
      </BoldedTabList>

      <Outlet />
    </TippingMainContainerStyled>
  )
}
